import React, { useState } from "react";
import Table from "./Table/Table";
import GeneralFilters from "./Filters/GeneralFilters";
import PreTable from "./Table/PreTable";
import AlternativeResults from "./Table/AlternativeResults";

import FiltersList from './Filters/FiltersList';

const App = props => {
  const [filtersAreOpen, setFiltersAreOpen] = useState(true);

  const onFiltersToggle = () => {
    setFiltersAreOpen(!filtersAreOpen);
  };

  return (
    <div className="product-finder view view-product-search">
      <div className="view-filters">
        <GeneralFilters strings={props.strings} redirectMode={false} />
      </div>
      <div className="view-content-wrapper">
        <PreTable
          onFiltersToggle={onFiltersToggle}
          filtersAreOpen={filtersAreOpen}
          strings={props.strings}
          settings={props.settings} />

        <div className={`product-finder__body ${filtersAreOpen ? 'is-open' : ''}`}>
          <div className={`product-finder__aside ${filtersAreOpen ? 'is-open' : ''}`}>
            <FiltersList />
          </div>
          <div className="product-finder__main">
            <Table {...props} />
          </div>
        </div>
        <AlternativeResults {...props} />
      </div>
    </div>
  );
};

export default App
